module.exports = __webpack_public_path__ + "static/media/golf-club.cfc76173.svg";